export function naira(amount) {
  const n = Number(amount || 0);
  return "₦" + n.toLocaleString("en-NG", { minimumFractionDigits: 0, maximumFractionDigits: 2 });
}

export function fmtDate(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString("en-NG", { year: "numeric", month: "short", day: "numeric" });
  } catch {
    return iso;
  }
}

export function fmtDateTime(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString("en-NG", { dateStyle: "medium", timeStyle: "short" });
  } catch {
    return iso;
  }
}

// operational status -> tailwind classes
export function opStatusClass(status) {
  const map = {
    "Quote Requested": "bg-slate-100 text-slate-700 border-slate-200",
    "Quote Sent": "bg-amber-50 text-amber-800 border-amber-200",
    "Quote Accepted": "bg-blue-50 text-blue-800 border-blue-200",
    "Awaiting Payment": "bg-[#FBF3D5] text-[#7A5C00] border-[#E5B800]",
    "Payment Confirmed": "bg-emerald-50 text-emerald-800 border-emerald-200",
    "Scheduled": "bg-emerald-50 text-emerald-800 border-emerald-200",
    "Preparing for Dispatch": "bg-emerald-50 text-emerald-800 border-emerald-200",
    "Dispatched": "bg-[#0A4F35]/10 text-[#0A4F35] border-[#0A4F35]/30",
    "In Transit": "bg-[#0A4F35]/10 text-[#0A4F35] border-[#0A4F35]/30",
    "Delivered": "bg-emerald-100 text-emerald-900 border-emerald-300",
    "Completed": "bg-emerald-100 text-emerald-900 border-emerald-300",
    "Cancelled": "bg-red-50 text-red-700 border-red-200",
  };
  return map[status] || "bg-slate-100 text-slate-700 border-slate-200";
}

export function payStatusClass(status) {
  const map = {
    "Unpaid": "bg-red-50 text-red-700 border-red-200",
    "Deposit Required": "bg-[#FBF3D5] text-[#7A5C00] border-[#E5B800]",
    "Deposit Paid": "bg-blue-50 text-blue-800 border-blue-200",
    "Partially Paid": "bg-amber-50 text-amber-800 border-amber-200",
    "Fully Paid": "bg-emerald-100 text-emerald-900 border-emerald-300",
    "Overdue": "bg-red-100 text-red-800 border-red-300",
  };
  return map[status] || "bg-slate-100 text-slate-700 border-slate-200";
}

export const CATEGORY_LABEL = {
  new_standard: "New / Standard (100% Prepaid)",
  deposit: "Approved Deposit Customer",
  credit: "Approved Credit / Contract",
};
